import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderAdminNoteEntity } from '../../domain/entities/OrderAdminNoteEntity'
export class OrderAdminNoteModel extends OrderAdminNoteEntity {
  constructor(dataDto: OrderAdminNoteModel) {
    super()
    mapEntityProperties<OrderAdminNoteEntity>(this, dataDto)
  }
}
